import { OnboardingWizard } from "@/features/onboarding/Wizard";

/**
 * Onboarding flow — BRD §3.1 "Effet Ikea" / progressive profiling.
 * State persists across page reloads via Capacitor Preferences (web + native).
 *
 * TODO(onboarding-resume-toast): notify the user when we restore a half-finished
 * onboarding session, with a "recommencer" escape hatch.
 */
export function OnboardingPage() {
  return <OnboardingWizard />;
}
